import { AccountingPlatform, AccountingPlatformCategory, apiClient } from '@melio/javascript-sdk';

import { useCollectionApi, UseCollectionApiProps } from '../../core';
import { AccountingPlatformCategoryCollection } from './types';

type UseAccountingPlatformCategoriesProps = UseCollectionApiProps<AccountingPlatformCategory> & {
  accountingPlatformId?: AccountingPlatform['id'];
};

export const useAccountingPlatformCategories = (
  props: UseAccountingPlatformCategoriesProps
): AccountingPlatformCategoryCollection => {
  const { accountingPlatformId } = props;
  const client = apiClient.accountingPlatformCategories(accountingPlatformId as string);

  return useCollectionApi({
    ...props,
    queryKey: ['accounting-platform-categories', accountingPlatformId],
    queryFn: () => client.fetch(),
    enabled: props.enabled && !!accountingPlatformId,
  });
};
